/**
 * Detects Safari browser.
 * !IMPORTANT only use when necessary
 * @returns {boolean}
 */
export const isSafari = function() {
  const ua      = navigator.userAgent;              // whole UA string
  const vendor  = navigator.vendor || '';           // "Apple Computer, Inc." in Safari
  const isApple = vendor === 'Apple Computer, Inc.' // only Safari reports this

  const hasSafari = /Safari/.test(ua);              // every Safari has “… Safari/605.1.15”
  const otherWebKit =
        /CriOS|Chrome|Chromium|Edg|OPR|Opera|FxiOS|Firefox/i.test(ua);

  return isApple && hasSafari && !otherWebKit;
}
